import styled from "styled-components";

import Button from "src/components-v2/Button";
import Field from "src/components-v2/Field";

import { colors, typography, zIndex } from "src/assets/styles/settings";

export const SearchWrapper = styled.div`
  display: flex;
  flex: 1;
  order: 1;
`;

export const SearchFieldWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;

  > input {
    min-width: 100px;
  }
`;

export const SearchField = styled(Field)<{ withPrepend?: boolean }>`
  border-radius: ${({ withPrepend }) => (withPrepend ? "0" : "4px")};
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const ClearButton = styled.button`
  background: transparent;
  position: absolute;
  right: 14px;
  padding: 0;
  font-size: ${typography.font_size.medium};
  z-index: ${zIndex.searchClearButton};
  color: ${colors.dark_grey};

  &:focus {
    outline: none;
  }
`;

export const SearchButton = styled(Button)`
  order: 2;
  border-radius: 0 4px 4px 0;
`;
